import { create } from "zustand";
import { flageIcon, shareIcon, trashIcon, downloadIcon, taskIcon, blockUserIcon, boringUserIcon, cameraIcon, uploadIcon, marketingIcon } from "assets";
import { AppLog } from "services";
import { StatusMsg } from "utils";
import { Service } from "utils/services";

type PostOptionItem = {
  key: string;
  label: string;
  sub_title: string;
  image: string;
  themeable: boolean;
  available: boolean;
};

type PostOptionsState = {
  post: any;
  options: Record<string, PostOptionItem>;
  initializePage: (post: any) => Promise<void>;
};

export const usePostOptions = create<PostOptionsState>((set) => ({
  post: null,
  options: {},

  initializePage: async (post: any) => {
    try {
      let tmpOptions: Record<string, PostOptionItem> = {
        boost: {
          key: "boost_post",
          label: "Promote Post",
          sub_title: "Promote post to increase a post’s reach.",
          image: marketingIcon,
          themeable: true,
          available: false,
        },
        report: {
          key: "report",
          label: "Report Post",
          sub_title: "Report inappropriate or harmful content.",
          image: flageIcon,
          themeable: true,
          available: false,
        },
        share: {
          key: "share",
          label: "Share Post",
          sub_title: "Repost content to share with your followers.",
          image: shareIcon,
          themeable: true,
          available: true,
        },
        delete: {
          key: "delete",
          label: "Delete Post",
          sub_title: "Remove your post or content permanently.",
          image: trashIcon,
          themeable: true,
          available: false,
        },
        save_photo: {
          key: "save_photo",
          label: "Save Photo",
          sub_title: "Save photos to view them later.",
          image: downloadIcon,
          themeable: true,
          available: false,
        },
        save_video: {
          key: "save_video",
          label: "Save Video",
          sub_title: "Save videos to watch later.",
          image: downloadIcon,
          themeable: true,
          available: false,
        },
        edit_post: {
          key: "edit_post",
          label: "Edit Content",
          sub_title: "Update or modify your post anytime.",
          image: taskIcon,
          themeable: true,
          available: false,
        },
        block_user: {
          key: "block_user",
          label: "Block User",
          sub_title: "Restrict a user from interacting with you.",
          image: blockUserIcon,
          themeable: true,
          available: false,
        },
        boring_user: {
          key: "boring_user",
          label: "Boring User",
          sub_title: "Mute users to stop seeing their posts.",
          image: boringUserIcon,
          themeable: true,
          available: false,
        },
        use_sound: {
          key: "use_sound",
          label: "Post Music",
          sub_title: "Add music to your posts for a fun.",
          image: cameraIcon,
          themeable: true,
          available: false,
        },
        restore: {
          key: "restore",
          label: "Restore Post",
          sub_title: "Bring back a deleted post to your feed.",
          image: uploadIcon,
          themeable: true,
          available: false,
        },
      };

      const mediaType = post.media_type.toLowerCase();

      console.log("mediaType : ", mediaType);

      if (mediaType === "photo" || mediaType === "album") {
        tmpOptions.save_photo.available = true;
      } else if (mediaType === "video") {
        tmpOptions.save_video.available = true;
        tmpOptions.use_sound.available = true;
        // tmpOptions.save_sound.available = false;
      }

      if (post.sound_url) {
        tmpOptions.use_sound.available = true;
      }

      if (`${post.user_id}` === `${Service.userAuth.id}`) {
        if (Service.toInteger(post.is_deleted) === 1) {
          tmpOptions.restore.available = true;
          tmpOptions.delete.available = false;
          tmpOptions.boost.available = false;
        } else {
          tmpOptions.restore.available = false;
          tmpOptions.delete.available = true;
          tmpOptions.boost.available = true;
        }

        if (Service.toInteger(post.re_post_user_id) === 0) {
          tmpOptions.edit_post.available = true;
        } else {
          if (`${post.re_post_user_id}` === `${post.user_id}`) {
            tmpOptions.edit_post.available = true;
          } else {
          }
        }
      } else {
        tmpOptions.block_user.available = true;
        tmpOptions.boring_user.available = true;
        tmpOptions.report.available = true;
      }

      if (mediaType === "update_profile_picture" || mediaType === "update_profile_cover" || mediaType === "update_profile_professional") {
        if (post.sound_url) {
          tmpOptions.use_sound.available = true;
        }
        tmpOptions.share.available = false;
        tmpOptions.delete.available = false;
        tmpOptions.edit_post.available = false;
        tmpOptions.report.available = false;
      }

      // todo : we will implement later
      tmpOptions.save_photo.available = false;
      tmpOptions.save_video.available = false;
      tmpOptions.use_sound.available = false;

      set({ post: post, options: tmpOptions });
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },
}));

